export default __webpack_public_path__ + "static/media/footer-icons.857f0149.svg";